module.exports = __webpack_public_path__ + "img/podcasts-2.725afbae.png";